import * as yup from "yup"

export const stockSchema = yup.object({
  items: yup.array().of(
    yup.object({
      product_id: yup.number().optional(),
      location_id: yup.number().optional(),
      mr_product_category_id: yup.number().optional(),
      mr_unit_id: yup.number().optional(),
      min_qty: yup.number().required().min(0, "Min qty not valid"),
      max_qty: yup.number().required().min(0, "Max qty not valid"),
    })
  )
})


export type FormSetStockType = yup.InferType<typeof stockSchema>
